import React from 'react';

import { ICustomList } from '../AddToList/shared';
import Box from 'components/elements/Box';
import { Heading, Image } from './styles';
import P from 'components/elements/p';
import formatDate from 'helpers/formatDate';

interface IModalCustomListInfoProps {
  customList: ICustomList;
}

const ModalCustomListInfo: React.FC<IModalCustomListInfoProps> = (props) => {
  const { customList } = props;

  return (
    <Box display="flex">
      <Box flex="0 0 auto" width="5em" height="5em">
        <Image
          src={customList.thumbnailUrl}
          alt={`artwork for ${customList.displayName}`}
        />
      </Box>
      <Box
        px={2}
        display="flex"
        flexDirection="column"
        justifyContent="space-between"
        width="100%"
      >
        <Heading>{customList.displayName}</Heading>
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="baseline"
          width="100%"
        >
          <P my={0} fontSize={1} color="CasperGrey">
            Last updated{' '}
            {customList.lastUpdatedAt &&
              formatDate(new Date(customList.lastUpdatedAt), 'day-short')}
          </P>
        </Box>
      </Box>
    </Box>
  );
};

export default ModalCustomListInfo;
